import React from 'react';
import moment from 'moment';

export const LastStockUpdate = (props) => {

    let style = {fontWeight: 'bold', fontSize: 'medium'};

    if(!props.lastUpdatedAt) {
        return (
            <span style={style}>unbekannt</span>
        );
    }

    const sameTimeYesterday = moment().subtract(24, 'hours');
    const timeOfLastStockUpdate = moment.utc(props.lastUpdatedAt);

    const lastStockUpdateFormatted = moment.utc(props.lastUpdatedAt).local().format('DD.MM.YYYY HH:mm');

    if (timeOfLastStockUpdate.isBefore(sameTimeYesterday)) {
        style.color = 'red';
    }

    return (
        <span style={style}>{lastStockUpdateFormatted}</span>
    );

};

export default LastStockUpdate;


// WEBPACK FOOTER //
// ./src/admin/scheduledreplenishment/LastStockUpdate.js